import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import "./hero-quest.css";
import CTAForm from "../CTAForm";

export default function QuestHero() {
  const qWrapperRef = useRef(null);
  const [showCTAForm, setShowCTAForm] = useState(false);

  useEffect(() => {
    const el = qWrapperRef.current;
    if (!el) return;

    // 1️⃣ base CSS position pe set karo
    gsap.set(el, {
      xPercent: -50,
      y: 0,
      opacity: 1,
    });

    // 2️⃣ sirf EK BAAR rect measure karo (yehi master reference hoga)
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight;
    const { top, bottom, height } = rect;

    if (!height) return;

    const EXTRA_BELOW = 20; // dunes ke andar kitna extra chhupana hai
    const EXTRA_ABOVE = 20; // upar kitna extra nikal jana hai

    // 🔹 start: pura pattern screen ke neeche (dunes ke andar)
    const startY = vh - top + EXTRA_BELOW;

    // 🔹 end: pura pattern screen ke upar
    const endY = -bottom - EXTRA_ABOVE;

    let tween = null;

    const loop = () => {
      // har cycle EXACT yahi se start hoga
      tween = gsap.fromTo(
        el,
        { y: startY },
        {
          y: endY,
          duration: 18, // speed yahi se control (15–20 slow, 8–12 fast)
          ease: "none",
          onComplete: loop, // jaise hi poora upar gaya, turant next rise
        }
      );
    };

    // first cycle
    loop();

    return () => {
      if (tween) tween.kill();
    };
  }, []);

  const handleBack = () => {
    console.log("Back clicked");
  };

  const handleJoinQuest = () => {
    setShowCTAForm(true);
  };

  const handleCloseModal = () => {
    setShowCTAForm(false);
  };

  const handleFollowX = () => {
    window.open(
      "https://x.com/nemeqworld?s=21&t=m3JsI_hPCH20Prrqxn2_SQ",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      <section className="hq-root">
        <div className="hq-scene">
        <img src="/sky-bg.svg" className="hq-sky" alt="" />
        <div className="hq-red-glow" />

        {/* BACK BUTTON – sirf text arrow */}
        <button
          type="button"
          className="hq-back-btn"
          onClick={handleBack}
          aria-label="Go back"
        >
          <span className="hq-back-btn-icon">‹</span>
        </button>

        {/* JOIN THE QUEST CTA – sirf text arrow */}
        <button type="button" className="hq-cta-btn" onClick={handleJoinQuest}>
          <span className="hq-cta-arrow">
            <span className="hq-cta-arrow-icon">›</span>
          </span>
          <span className="hq-cta-label">Join The Quest</span>
        </button>

        {/* FOLLOW US ON X */}
        <button type="button" className="hq-follow-x" onClick={handleFollowX}>
          <span className="hq-follow-x-label">Follow us on</span>
          <span className="hq-follow-x-icon">X</span>
        </button>

        {/* Q pattern */}
        <div ref={qWrapperRef} className="hq-q-wrapper">
          <img src="/q-pattern.svg" className="hq-q" alt="" />
        </div>

        {/* Dunes */}
        <div className="hq-dunes">
          <div className="hq-dune hq-dune-left">
            <img src="/left-dune.svg" alt="" style={{ width: "100vw" }} />
          </div>
          <div className="hq-dune hq-dune-right">
            <img src="/right-dune.svg" alt="" style={{ width: "100vw" }} />
          </div>
        </div>

        {/* Silhouette */}
        <img src="/silhouette.svg" className="hq-person" alt="" />
      </div>
    </section>
      {showCTAForm && (
        <div
          className="hq-modal-overlay"
          role="dialog"
          aria-modal="true"
          onClick={(event) => {
            if (event.target === event.currentTarget) {
              handleCloseModal();
            }
          }}
        >
          <div className="hq-modal-content">
            <button
              type="button"
              className="hq-modal-close"
              aria-label="Close form"
              onClick={handleCloseModal}
            >
              ×
            </button>
            <CTAForm />
          </div>
        </div>
      )}
    </>
  );
}
